import { createContext } from 'react'

export { default as CollectionPoints } from './master'
export { default as CollectionLocationCard } from './CollectionLocationCard'
export { default as CollectionPointsQuotas } from './quotas'

export const CollectionPointsContext = createContext()